/* 


@PRAKT


   _____________________________________________________________

   |
   | CUSTOMER LOCALIZATION
   |
   _____________________________________________________________
*/

import gsap from 'gsap';

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class CustomerLocalization {
    constructor() {
        this.init();
    }

    init() {
        this.active = JSON.parse( window.hcc_market_info) ;
        // console.log(this.active);
        if( !this.active ) return;
        this.mode = 'cookie'; // 'session' or 'cookie'
        this.countries = window.hcc_countries;
        if( !this.countries ) return;
        this.localize = window.hcc_countries_content;
        this.delay = Number( window.hcc_countries_content.delay );
        this.stored_country = sessionStorage.getItem( 'hcc_user_location' );
        this.controlUserCountry();
    }

    checkLocation( country_code ) {
        // console.log('Mode', this.mode);
        // console.log('Stored country', this.stored_country);
        // console.log('Check once', this.check_once);
        // console.log('Cookie', this.getCookie( 'hcc_user_location_checked' ) );
        // console.log( sessionStorage );
        
        if( this.mode == 'session' ) {
            this.check_once = Boolean( sessionStorage.getItem( 'hcc_user_location_checked' ) );
            if( this.check_once ) return;
            if ( !this.countries.includes( country_code ) ) { // prod
            // if ( this.countries.includes( country_code ) ) { // test
                this.buildModal();
            }
            if( !this.check_once ) sessionStorage.setItem( 'hcc_user_location_checked', 'true' );
        } else if( this.mode == 'cookie' ) {
            if ( !this.getCookie( 'hcc_user_location_checked' ) ) {
                if ( !this.countries.includes( country_code ) ) { // prod
                // if ( this.countries.includes( country_code ) ) { // test
                    this.buildModal();
                }
                this.setCookie( 'hcc_user_location_checked', 'true', this.delay ); // Xh -› needs to update time in getCookie
                // this.setCookie( 'hcc_user_location_checked', 'true', 30 ); // 30s test -› needs to update time in getCookie
            }
        }
    }

    setCookie(name, value, hours) { // prod
    // setCookie(name, value, seconds) { // test
        let date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));  // Xh prod
        // date.setTime(date.getTime() + (seconds * 1000)); // 30s test
        document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    }

    getCookie(name) {
        let cookies = document.cookie.split('; ');
        for (let cookie of cookies) {
            let [key, value] = cookie.split('=');
            if (key === name) return value;
        }
        return null;
    }

    controlUserCountry() {
        if ( this.stored_country ) {
            this.checkLocation( this.stored_country );
            return;
        }

        if ( 'geolocation' in navigator && this.mode == 'session' ) {
            navigator.geolocation.getCurrentPosition( async ( position ) => {
                const { latitude, longitude } = position.coords;
                try {
                    const response = await fetch( `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}` );
                    const data = await response.json();
                    const countryCode = data.address?.country_code?.toUpperCase();
                    if ( countryCode ) {
                        sessionStorage.setItem( 'hcc_user_location', countryCode );
                        this.checkLocation( countryCode );
                    }
                } catch ( error ) {
                    console.error( 'ERR OSM:', error );
                }
            }, async () => {
                this.fetchIPLocation();
            });
        } else {
            if( !this.getCookie( 'hcc_user_location_checked' ) ) this.fetchIPLocation();
        }
    }

    async fetchIPLocation() {
        try {
            const response = await fetch( 'https://ipinfo.io/json?token=f4ce6d8b2ff51c' );
            const data = await response.json();
            const countryCode = data.country?.toUpperCase();
            if ( countryCode ) {
                sessionStorage.setItem( 'hcc_user_location', countryCode );
                this.checkLocation( countryCode );
            }
        } catch ( error ) {
            console.error( 'ERR IP:', error );
        }
    }

    buildModal() {
        const append_target = document.querySelector( 'body' );
        const modal = document.createElement( 'div' );
        const overlay = document.createElement( 'div' );
        const inner = document.createElement( 'div' );
        const title = document.createElement( 'h2' );
        const message = document.createElement( 'div' );
        const image = document.createElement( 'div' );
        const button = document.createElement( 'div' );

        modal.id = 'customer_localization_alert';
        inner.className = 'inner';
        overlay.className = 'overlay';
        title.className = 'title';
        message.className = 'message';
        image.className = 'image';
        button.className = 'button';
        button.classList.add( 'button--primary' );
        title.innerHTML = this.localize.title;
        message.innerHTML = this.localize.message;
        button.innerHTML = this.localize.button;

        inner.appendChild( image );
        inner.appendChild( title );
        inner.appendChild( message );
        inner.appendChild( button );
        modal.appendChild( overlay );
        modal.appendChild( inner );
        append_target.appendChild( modal );

        button.addEventListener( 'click', () => {
            this.closeModal();
        } );
        overlay.addEventListener( 'click', () => {
            this.closeModal();
        } );
    }

    closeModal() {
        const modal = document.querySelector( '#customer_localization_alert' );
        const inner = modal.querySelector( '.inner' );
        const tl = gsap.timeline();
        tl.to( inner, {
            duration: 0.2,
            ease: 'power3.inOut',
            y: '2rem',
            opacity: 0
        } );
        tl.to( modal, {
            duration: 0.2,
            ease: 'power3.inOut',
            opacity: 0,
            onComplete: () => {
                modal.remove();
            }
        } );
    }
}